import { Routes, UrlSegment } from '@angular/router';
import { authGuard, createAuthCallbackRoute, createLoggedOutRoute } from '@presencelearning/auth';
import { AboutComponent } from './about/about.component';
import { AuthCallbackComponent } from './auth/auth-callback.component';
import { LoggedOutComponent } from './auth/logged-out.component';
import { HomeComponent } from './home/home.component';
import { ProviderDoorComponent } from './room/provider-door.component';
import { StudentDoorComponent } from './room/student-door.component';
import { ShellComponent } from './shell/shell.component';

const reservedRooms = new Set(['session', 'about', 'join', 'auth']);

export function isRoomRoute(_route: unknown, segments: UrlSegment[]): boolean {
  return segments.length === 1 && !reservedRooms.has(segments[0].path.toLowerCase());
}

export const routes: Routes = [
  createAuthCallbackRoute({ component: AuthCallbackComponent }),
  createLoggedOutRoute({ component: LoggedOutComponent }),
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      { path: '', component: HomeComponent },
      { path: 'session', component: ProviderDoorComponent },
      { path: 'about', component: AboutComponent },
    ],
  },
  // Students have no Sirius account. The segment is the leader's room id.
  // They wait to be admitted in the video room. This route stays outside the frame.
  { path: ':roomId', component: StudentDoorComponent, canMatch: [isRoomRoute] },
];
